export enum PermissionTypesEnum {
  // Admin - Uzivatele
  ADMIN_USER_READ = 'ADMIN_USER_READ',
  ADMIN_USER_CREATE = 'ADMIN_USER_CREATE',
  ADMIN_USER_UPDATE = 'ADMIN_USER_UPDATE',
  ADMIN_USER_DELETE = 'ADMIN_USER_DELETE',
  ADMIN_USER_RESET_PASSWORD = 'ADMIN_USER_RESET_PASSWORD',

  // Admin - Role
  ADMIN_ROLE_READ = 'ADMIN_ROLE_READ',
  ADMIN_ROLE_CREATE = 'ADMIN_ROLE_CREATE',
  ADMIN_ROLE_UPDATE = 'ADMIN_ROLE_UPDATE',
  ADMIN_ROLE_DELETE = 'ADMIN_ROLE_DELETE',

  // Admin - Security Groups
  ADMIN_SECURITY_GROUP_READ = 'ADMIN_SECURITY_GROUP_READ',
  ADMIN_SECURITY_GROUP_CREATE = 'ADMIN_SECURITY_GROUP_CREATE',
  ADMIN_SECURITY_GROUP_UPDATE = 'ADMIN_SECURITY_GROUP_UPDATE',
  ADMIN_SECURITY_GROUP_DELETE = 'ADMIN_SECURITY_GROUP_DELETE',

  // Admin - Organizace
  ADMIN_ORGANIZATION_READ = 'ADMIN_ORGANIZATION_READ',
  ADMIN_ORGANIZATION_FEATURE_EDIT = 'ADMIN_ORGANIZATION_FEATURE_EDIT',
  ADMIN_ORGANIZATION_EXPORT = 'ADMIN_ORGANIZATION_EXPORT',
  ADMIN_ORGANIZATION_IMPORT = 'ADMIN_ORGANIZATION_IMPORT',

  // Admin - Produkty
  ADMIN_PRODUCT_READ = 'ADMIN_PRODUCT_READ',
  ADMIN_PRODUCT_IMAGE_UPLOAD = 'ADMIN_PRODUCT_IMAGE_UPLOAD',
  ADMIN_PRODUCT_IMAGE_UPDATE = 'ADMIN_PRODUCT_IMAGE_UPDATE',
  ADMIN_PRODUCT_IMAGE_DELETE = 'ADMIN_PRODUCT_IMAGE_DELETE',

  // Admin - Kategorie
  ADMIN_CATEGORY_READ = 'ADMIN_CATEGORY_READ',

  // Admin - Aukce
  ADMIN_AUCTION_READ = 'ADMIN_AUCTION_READ',

  // Admin - Objednavky
  ADMIN_ORDER_READ = 'ADMIN_ORDER_READ',
  ADMIN_ORDER_UPDATE = 'ADMIN_ORDER_UPDATE',

  // Admin - Clanky
  ADMIN_ARTICLE_READ = 'ADMIN_ARTICLE_READ',
  ADMIN_ARTICLE_CREATE = 'ADMIN_ARTICLE_CREATE',
  ADMIN_ARTICLE_UPDATE = 'ADMIN_ARTICLE_UPDATE',
  ADMIN_ARTICLE_DELETE = 'ADMIN_ARTICLE_DELETE',

  // Admin - Emaily
  ADMIN_EMAIL_READ = 'ADMIN_EMAIL_READ',
  ADMIN_EMAIL_WRITE = 'ADMIN_EMAIL_WRITE',

  // Admin - Sync requesty
  ADMIN_SYNC_REQUEST_READ = 'ADMIN_SYNC_REQUEST_READ',
  ADMIN_SYNC_REQUEST_WRITE = 'ADMIN_SYNC_REQUEST_WRITE',

  // Admin - Inicialni load z externiho systemu
  ADMIN_PERFORM_INICIAL_LOAD = 'ADMIN_PERFORM_INICIAL_LOAD',

  // Admin - Docteni dat firmy ze stareho nakupniho portalu
  ADMIN_LOAD_NP_DATA = 'ADMIN_LOAD_NP_DATA',

  // Admin - Elastic
  ADMIN_ELASTIC_READ = 'ADMIN_ELASTIC_READ',

  // Admin - Ulohy
  ADMIN_TASK_READ = 'ADMIN_TASK_READ',

  // Admin - Sessions
  ADMIN_SESSION_READ = 'ADMIN_SESSION_READ',
  ADMIN_SESSION_DELETE = 'ADMIN_SESSION_DELETE',

  // Client - Sprava uzivatelu
  CLIENT_USER_READ = 'CLIENT_USER_READ',
  CLIENT_USER_CREATE = 'CLIENT_USER_CREATE',
  CLIENT_USER_EDIT = 'CLIENT_USER_EDIT',
  CLIENT_USER_DELETE = 'CLIENT_USER_DELETE',
  CLIENT_USER_ROLE_EDIT = 'CLIENT_USER_ROLE_EDIT',
  CLIENT_USER_GROUP_EDIT = 'CLIENT_USER_GROUP_EDIT',

  // Vlastní dodavatelé
  CLIENT_MANUAL_SUPPLIER_ADD = 'CLIENT_MANUAL_SUPPLIER_ADD',
  CLIENT_MANUAL_SUPPLIER_DELETE = 'CLIENT_MANUAL_SUPPLIER_DELETE',

  // Vlastní produkty - přenos mezi společnostmi (XLSX)
  CLIENT_CUSTOM_PRODUCT_EXPORT = 'CLIENT_CUSTOM_PRODUCT_EXPORT',
  CLIENT_CUSTOM_PRODUCT_IMPORT = 'CLIENT_CUSTOM_PRODUCT_IMPORT',

  // AI asistent (kuchařský asistent v chat sidebaru)
  CLIENT_AI_ASSISTANT_USE = 'CLIENT_AI_ASSISTANT_USE',

  // Plánované objednávky (prémiová funkce SCHEDULED_ORDERS)
  CLIENT_SCHEDULED_ORDER_READ = 'CLIENT_SCHEDULED_ORDER_READ',
  CLIENT_SCHEDULED_ORDER_CREATE = 'CLIENT_SCHEDULED_ORDER_CREATE',
  CLIENT_SCHEDULED_ORDER_APPROVE = 'CLIENT_SCHEDULED_ORDER_APPROVE',
}
